<template>
	<div v-if="showAll" class="create-offer__new" v-loading.fullscreen.lock="fullscreenLoading">
		<div v-if="!isViewMode" class="select-model">
			<p style="font-size: 16px; color: #ff0000;">*Внимание! Технические характеристики и наличие моделей
				уточняйте у менеджера по продажам — часть моделей может быть снята с производства.</p>
			<v-select v-model="category" label="name" :options="categories" placeholder="Выберите категорию"></v-select>
			<v-select v-if="computedBrands.length > 0 || brand !== null" v-model="brand" label="name"
				:options="computedBrands" placeholder="Выберите бренд"></v-select>
			<v-select v-if="computedModels.length > 0 || model !== null" @input="onChangeModel" v-model="model"
				label="product_model" :options="computedModels" placeholder="Выберите модель"></v-select>
			<v-select v-if="masts.length > 0 || mast !== null" @input="updateMast" v-model="mast" label="name"
				:options="masts" placeholder="Выберите мачту"></v-select>
		</div>

		<div class="attributes-container" style="position: relative">
			<div class="attributes-header">
				<span class="product-name">{{ productName }}</span>

				<el-button v-show="attributes" class="copy-button" @click="copyTable">
					Скопировать все
				</el-button>
			</div>
			<div class="attributes-description">
				<img class="logo" :src="baseUrl + productBrandLogo" alt="" />
				<div v-html="productBrandContent" class="brand-content"></div>
			</div>
			<div class="attributes-images">
				<!-- <div v-if="rutube != ''" ref="canvas">
				</div> -->
				<img class="product" :src="baseUrl + productPhoto" alt="" />
			</div>

			<table ref="attributesTable" class="attributes-table" style="border-collapse: collapse;">
				<tbody>
					<tr v-for="(item, index) in attributes" :key="index"
						v-if="item[1] !== undefined && item[1].length > 0 && index < 24">
						<td style="border: 1px solid #ccc; padding: 6px; font-weight: bold;">
							{{ item[0] }}
						</td>
						<td style="border: 1px solid #ccc; padding: 6px;">
							{{ item[1] }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import { ADRESS } from '@/store/actions/auth'
import axios from 'axios'
import moment from 'moment'
import Fetch from './mixins/Fetch'
import QRCodeStyling from 'qr-code-styling'

export default {
	name: 'CreateOffer',
	mixins: [Fetch],
	data() {
		return {
			categories: [],
			category: null,
			brands: [],
			brand: null,
			models: [],
			model: null,
			masts: [],
			mast: null,
			productName: null,
			attributes: null,
			showAll: false,
			fullscreenLoading: false,
			isViewMode: false,
			offer_id: '',
			branches: [],
			branch: null,
			currencies: [],
			currency: null,
			qrCode: null,
			rutube: '',
		}
	},
	computed: {
		computedBrands() {
			if (this.models && this.brands && this.brands.length > 0) {
				const brands_id = [...new Set(this.computedModels.map(a => a.brand))]
				let brands = [...this.brands]
				if (this.category !== null) {
					brands = brands.filter(item => brands_id.includes(item.id))
				}
				return brands
			}
			return []
		},
		computedModels() {
			if (this.models && this.models.length > 0) {
				let models = [...this.models]
				if (this.category !== null) {
					models = models.filter(item => item.category === this.category.id)
				}
				if (this.brand !== null) {
					models = models.filter(item => item.brand === this.brand.id)
				}
				return models
			}
			return []
		},
	},
	methods: {
		async copyTable() {
			const container = document.createElement('div')

			const table = this.$refs.attributesTable
			if (table) {
				container.appendChild(table.cloneNode(true))
			}

			const logo = this.$el.querySelector('.attributes-description img.logo')
			if (logo) {
				const img = document.createElement('img')
				img.src = logo.src
				img.style.maxWidth = '200px'
				container.appendChild(img)
			}

			const product = this.$el.querySelector('.attributes-images img.product')
			if (product) {
				const img = document.createElement('img')
				img.src = product.src
				img.style.maxWidth = '300px'
				container.appendChild(img)
			}

			// if (this.qrCode && this.rutube) {
			// 	try {
			// 		const blob = await this.qrCode.getRawData()
			// 		const reader = new FileReader()
			// 		await new Promise((resolve) => {
			// 			reader.onloadend = () => {
			// 				const img = document.createElement('img')
			// 				img.src = reader.result
			// 				img.style.maxWidth = '300px'
			// 				container.appendChild(img)
			// 				resolve()
			// 			}
			// 			reader.readAsDataURL(blob)
			// 		})
			// 	} catch (e) {
			// 		console.warn('QR-код не удалось получить:', e)
			// 	}
			// }

			const brandContent = this.$el.querySelector('.brand-content')
			if (brandContent) {
				const div = document.createElement('div')
				div.innerHTML = brandContent.innerHTML
				container.appendChild(div)
			}

			try {
				const html = container.innerHTML
				const blob = new Blob([html], { type: 'text/html' })
				await navigator.clipboard.write([
					new ClipboardItem({ 'text/html': blob })
				])
				this.$notify.success({
					title: 'Скопировано',
					message: 'Данные скопированы с изображениями и описанием!',
				})
			} catch (err) {
				console.error(err)
				this.$notify.error({
					title: 'Ошибка',
					message: 'Не удалось скопировать. Попробуйте другой браузер.',
				})
			}
		},
		fetchData() {
			this.user_id = localStorage.getItem('used-id')
			if (this.user_id !== null) {
				this.showAll = true
			}
			this.getAllContent()
		},
		getAllContent() {
			axios.get(`${this.baseUrl}/api-crm/get-all-models/`).then(response => {
				this.categories = response.data.categories
				this.brands = response.data.brands
				this.models = response.data.products
				this.branches = response.data.branches
				this.currencies = response.data.currencies
				this.currency = this.currencies.find(el => el.name == 'RUB')
				const parameter = this.findGetParameter('open-offer')
				const isEdit = this.findGetParameter('is-edit') === 'true'
				if (parameter !== null) {
					this.isViewMode = !isEdit
					this.getOffer(parameter)
					this.offer_id = parameter
				}
			})
		},
		sortingAttr(attr) {
			const attributes = [...attr]
			let colLeftLength = Math.ceil(attributes.length / 2)
			let n = attributes.length % 2 === 1 ? attributes.length - colLeftLength + 1 : attributes.length - colLeftLength
			const arrAttr = []

			for (let i = 0; i < attributes.length; i++) {
				arrAttr.push(attributes[i])
				if (arrAttr.length === attributes.length) break

				arrAttr.push(attributes[n])
				n++
				if (arrAttr.length === attributes.length) break
			}
			return arrAttr
		},
		onChangeModel() {
			if (this.model !== null) {
				this.adaptive_content = null
				axios.get(`${this.baseUrl}/api-crm/get-model-content/`, {
					params: { product: this.model.product_model }
				})
					.then(response => {
						this.adaptive_content = response.data.adaptive_content
						this.productName = response.data.productName
						this.productBrandContent = response.data.productBrandContent
						this.productBrandLogo = response.data.productBrandLogo
						this.productPhoto = response.data.productPhoto
						this.rutube = response.data.rutube
						this.productContentHtml = 'content' in response.data ? response.data.content : null
						this.masts = response.data.masts
						const arr = response.data.attributes || []
						this.attributes = arr.filter(el => el[0] && el[1])
						this.attributes = this.sortingAttr(this.attributes)
						this.hasData = true
						this.$nextTick(() => {
							if (!this.qrCode) {
								this.qrCode = new QRCodeStyling({
									width: 300,
									height: 300,
									type: 'svg',
									data: `rutube.ru/play/embed/${this.rutube}/`,
									margin: -2,
								})
								this.qrCode.append(this.$refs.canvas)
							} else {
								this.qrCode.update({
									data: `rutube.ru/play/embed/${this.rutube}/`,
									image: '/assets/images/rutube.svg',
								})
							}
						})
					})
					.catch(err => {
						console.log(err)
						this.$notify.error({
							title: 'Ошибка',
							message: err,
						})
					})
			}
		},
		getOffer(offer_id) {
			axios.get(`${ADRESS}get-offer?id=` + offer_id).then(response => {
				this.hasData = true
				this.nameCompany = response.data.nameCompany
				this.companyInn = response.data.companyInn
				this.category = this.categories.find(item => item.name === response.data.category)
				this.brand = this.brands.find(item => item.name === response.data.brand)
				this.model = this.models.find(item => item.product_model === response.data.model)
				this.currency = this.currencies.find(el => el.name == response.data.currency)
				this.branch = this.branches.find(el => el.name == response.data.branch)
				this.managerName = response.data.managerName
				this.managerPhone = response.data.managerPhone
				this.managerMail = response.data.managerMail
				this.dateBefore = moment(response.data.dateBefore, 'DD.MM.YYYY hh:mm').format('DD.MM.YYYY')
				this.equipment = response.data.equipment
				this.delivery = response.data.delivery
				this.deliveryTime = response.data.deliveryTime
				this.payment = response.data.payment
				this.guarantee = response.data.guarantee
				this.price = response.data.price

				const arr = response.data.attributes || []
				this.attributes = arr.filter(el => el[0] && el[1])
				this.getContentFromModel(response.data.mast)
				if (this.isViewMode) {
					this.nameCompany = response.data.nameCompany
					this.number = response.data.number
				} else {
					this.number = 'XXXXXX'
				}
			})
		},
		getContentFromModel(mast) {
			axios.get(`${this.baseUrl}/api-crm/get-model-content/`, {
				params: { product: this.model.product_model }
			})
				.then(response => {
					this.masts = response.data.masts
					this.mast = this.masts.find(el => el.name == mast)
					this.productName = response.data.productName
					this.productBrandLogo = response.data.productBrandLogo
					this.productBrandContent = response.data.productBrandContent
					this.productPhoto = response.data.productPhoto
					this.adaptive_content = response.data.adaptive_content
				})
		},
		findGetParameter(parameterName) {
			let result = null
			window.location.search.substr(1).split('&').forEach(item => {
				const tmp = item.split('=')
				if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
			})
			return result
		},
		updateMast() {
			if (this.mast !== null && this.attributes !== null) {
				let attributes = [...this.attributes]
				this.mast.attributes.forEach(mast_attr => {
					if (mast_attr[1] !== null) {
						let b = 5
						if (attributes.some(item => item[0] == mast_attr[0])) {
							let attr_index = attributes.findIndex(item => item[0] == mast_attr[0])
							attributes[attr_index][1] = mast_attr[1]
						} else {
							b = b + 1
							attributes.splice(b, 0, [mast_attr[0], mast_attr[1]])
						}
					}
				})
				this.attributes = attributes
			}
		},
	},
}
</script>

<style lang="scss">
.create-offer__new {
	.select-model {
		padding: 0 20px;

		@media (max-width: 480px) {
			padding: 0 10px;
		}

		>div {
			margin: 15px 0;
			width: 80%;
			max-width: 400px;

			@media (max-width: 480px) {
				width: 100%;
				max-width: 100%;
			}
		}
	}

	p {
		margin-bottom: 0;
	}

	.attributes-description {
		display: grid;
		gap: 20px;

		.logo {
			max-width: 200px;
		}

		.brand-content {
			max-width: 600px;
		}
	}

	.attributes-images {
		display: grid;
		gap: 20px;
		align-items: center;
		justify-content: center;


		.product {
			max-width: 300px;
		}
	}

	.copy-button {
		max-width: fit-content;
	}

	.attributes-container {
		display: grid;
		gap: 20px;
		margin: 20px;
		font-size: 14px;
		max-width: 600px;
	}

	.attributes-header {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}
}
</style>
